import { render } from "./BaseModal.vue?vue&type=template&id=1afff05a&ts=true"
import script from "./BaseModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseModal.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/BaseModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1afff05a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1afff05a', __exports__)) {
    api.reload('1afff05a', __exports__)
  }
  
  module.hot.accept("./BaseModal.vue?vue&type=template&id=1afff05a&ts=true", () => {
    api.rerender('1afff05a', render)
  })

}


export default __exports__